import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import type { QuickFilterListItem } from '../../../components/pages/QuickFilters/types';

const path = '/admin/quick-filters/display-order' as const;

type PayloadProps = {
  dayPackage: boolean;
  ids: number[];
};

export const useUpdateOrderQuickFilters = () => {
  return useMutation<QuickFilterListItem[], unknown, PayloadProps, unknown>({
    mutationFn: async (payload: PayloadProps) =>
      apiMutation(
        'PATCH',
        {
          path: path,
        },
        payload
      ),
    onSuccess: () => {
      message.success('List successfully updated');
    },
    onError: () => {
      message.error('Error while updating the list');
    },
  });
};
